import React, { useContext } from "react";
import { Box, CircularProgress, Container, Grid } from "@mui/material";
import Layout from "components/layout/layout";
import { useParams } from "react-router-dom";

import { ReactComponent as Dollar } from "./../../assets/Icons/dollar.svg";
import { TransactionDetailsCard } from "components/transaction-details/transaction-details";
import { TransactionDetailsItem } from "components/transaction-details/transaction-details-item";
import { shortFormat } from "utils/date-format";
import { BackToPreviousButton } from "components/shared/back-to-previous-button";
import { AuthContext } from "providers/userProvider";
import { AuthData } from "types/auth";
import { useGetFundGvDistributionQuery } from "hooks/use-services/fund-gv-distribution.service";
export const GvDistributionTransactionDetailsPage = () => {
  const { id } = useParams();
  const { selectedAccount } = useContext<AuthData>(AuthContext);
  const {
    data: distributionData,
    isSuccess,
    isFetching,
    isLoading,
  } = useGetFundGvDistributionQuery({
    fundAccountId: selectedAccount?.fundAccountId || 0,
    distributionId: id ? +id : 0,
  });

  return (
    <Layout>
      {() => (
        <>
          <Box sx={{ my: 4, width: "100%" }}>
            <React.Fragment>
              <Container>
                {isFetching ||
                  (isLoading && <CircularProgress size={20} color="inherit" />)}
                {isSuccess && distributionData && (
                  <Grid sx={{ m: 5 }} container spacing={2}>
                    <Grid item xs={12} sm={9}>
                      <BackToPreviousButton />
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TransactionDetailsCard
                        amount={distributionData.amountDistributed}
                        type="GV DISTRIBUTION"
                        title={distributionData.grantvestment.name}
                        avatar={<Dollar />}
                        status={"PROCESSED"}
                      >
                        <TransactionDetailsItem
                          label="Type"
                          value={`GrantVestment Distribution`}
                        />
                        <TransactionDetailsItem
                          label="Comment"
                          value={`${distributionData.comment || "-"}`}
                        />
                        <TransactionDetailsItem
                          label="DATE"
                          value={shortFormat(distributionData.distributionDate)!}
                        />
                        <TransactionDetailsItem
                          label="INITIATED BY"
                          value={`${distributionData.user.firstName} ${distributionData.user.lastName}`}
                        />

                        <TransactionDetailsItem
                          label="Fund"
                          value={`${distributionData.fund.fundAccountName}`}
                        />
                      </TransactionDetailsCard>
                    </Grid>
                  </Grid>
                )}
              </Container>
            </React.Fragment>
          </Box>
        </>
      )}
    </Layout>
  );
};
